import { HexOutline, HexPattern } from '../brand/Hexagon';
import { Button } from '../ui/Button';
import { Eyebrow } from '../ui/SectionHeading';
import { hero } from '../../content/site';

/**
 * Hero.
 *
 * La entrada usa `animate-fade-up` con escalones de stagger en vez del
 * IntersectionObserver de `Reveal`: este bloque siempre está sobre el fold, así
 * que animarlo con el observer sólo provocaría un parpadeo. La animación es
 * puramente CSS y `prefers-reduced-motion` la neutraliza desde el stylesheet.
 */
export function Hero() {
  return (
    <section
      id="inicio"
      className="relative overflow-hidden bg-surface-hero"
      aria-labelledby="hero-titulo"
    >
      {/* Motivo de hexágonos en la mitad derecha. Decorativo: fuera del árbol
          de accesibilidad y sin capturar clics. */}
      <div
        className="pointer-events-none absolute inset-y-0 right-0 w-full text-brand min-[861px]:w-3/5"
        aria-hidden="true"
      >
        <HexPattern className="h-full w-full" opacity={0.055} />
      </div>

      {/* El hero lleva más aire que el resto de secciones — valores del
          prototipo, no el .section-y compartido. */}
      <div className="shell relative pt-[clamp(84px,11vw,150px)] pb-[clamp(90px,11vw,150px)]">
        <div>
          <Eyebrow className="animate-fade-up stagger-0">{hero.eyebrow}</Eyebrow>

          {/* max-w 960px es el valor del prototipo: es lo que produce el corte
              de línea aprobado ("EL PRIMER MARKETPLACE / DE ABOGADO A ABOGADO").
              text-wrap: pretty evita que quede una palabra huérfana al final. */}
          <h1
            id="hero-titulo"
            className="animate-fade-up stagger-1 mt-7 max-w-[960px] text-[clamp(2.3rem,5.4vw,4.4rem)] leading-[1.06] tracking-[-0.015em] text-pretty text-ink"
          >
            {hero.titleBefore}
            <span className="text-brand">{hero.titleHighlight}</span>
            {hero.titleAfter}
          </h1>

          <p className="animate-fade-up stagger-2 mt-7 max-w-[620px] text-[18px] leading-[1.75] text-pretty text-ink-muted">
            {hero.paragraph}
          </p>

          <div className="animate-fade-up stagger-3 mt-9 flex flex-wrap gap-3.5">
            <Button
              href={hero.primaryCta.href}
              hint={hero.primaryCta.hint}
              variant="primary"
            >
              {hero.primaryCta.label}
            </Button>
            <Button
              href={hero.secondaryCta.href}
              hint={hero.secondaryCta.hint}
              variant="outline"
            >
              {hero.secondaryCta.label}
            </Button>
          </div>

          <p className="animate-fade-up stagger-4 mt-11 flex items-start gap-2.5 text-[13.5px] text-ink-soft">
            <HexOutline className="mt-px h-4 w-4 shrink-0 text-brand" />
            {hero.trust}
          </p>
        </div>
      </div>
    </section>
  );
}
